export const apiServer =
  import.meta.env.VITE_API_URL || "http://localhost:3000";
export const apiServer_v2 =
  import.meta.env.VITE_API_URL_V2 || "http://localhost:3000";
export const pubApiServer =
  import.meta.env.VITE_API_PUB_API_URL || "http://localhost:3000";

export const mixPanelToken = import.meta.env.VITE_MIXPANEL_TOKEN || "";

export const bucketUrlPrefix = import.meta.env.VITE_BUCKET_IMAGES_URL || "";
// RN app shows an error if this is not defined here, its not used in React JS app at all
export const bucketUrlPrefix_CDN = import.meta.env.VITE_BUCKET_IMAGES_URL || "";

export const googleMapKey = import.meta.env.VITE_GOOGLE_MAP_KEY || "";
export const googleMapId = import.meta.env.VITE_GOOGLE_MAP_ID || "";
export const googleMapDarkModeId =
  import.meta.env.VITE_GOOGLE_MAP_DARK_MODE_ID || "";

export const sliderMargin = "90%";

export const defaultRegion = {
  latitude: 51.5090583,
  longitude: -0.1305076,
  latitudeDelta: 0.01,
  longitudeDelta: 0.01,
};

export const defaultTagRegion = {
  latitude: 51.5090583,
  longitude: -0.1305076,
  latitudeDelta: 0.0035,
  longitudeDelta: 0.0035,
};

export const defaultUserLocation = {
  latitude: 51.5090583,
  longitude: -0.1305076,
};

export const gaTrackingId = import.meta.env.VITE_GA_TRACKING_ID;
export const gaDataLayerId = import.meta.env.VITE_GA_DATALAYER_ID;
export const gaMeasurementId = import.meta.env.VITE_GA_MEASUREMENT_ID;

export const googleLoginClientId = import.meta.env.VITE_GOOGLE_LOGIN_CLIENT_ID;
export const appleLoginClientId = import.meta.env.VITE_APPLE_LOGIN_CLIENT_ID;
export const appleLoginRedirectUri = import.meta.env
  .VITE_APPLE_LOGIN_REDIRECT_URI;
export const appleLoginDesktopRedirectUri = import.meta.env
  .VITE_APPLE_LOGIN_DESKTOP_REDIRECT_URI;
export const facebookLoginClientId = import.meta.env
  .VITE_FACEBOOK_LOGIN_CLIENT_ID;

export const shareServer = import.meta.env.VITE_SHARE_SERVER;

export const faqUrl = import.meta.env.VITE_FAQ_URL;
export const aboutUrl = import.meta.env.VITE_ABOUT_URL;
export const privacyUrl = import.meta.env.VITE_PRIVACY_URL;
export const termsUrl = import.meta.env.VITE_TERMS_URL;
export const howItWorksUrl = import.meta.env.VITE_HOW_IT_WORKS_URL;
// content pages links
export const publicFaqUrl = import.meta.env.VITE_PUBLIC_FAQ_URL;
export const publicAboutUrl = import.meta.env.VITE_PUBLIC_ABOUT_URL;
export const publicPrivacyUrl = import.meta.env.VITE_PUBLIC_PRIVACY_URL;
export const publicTermsUrl = import.meta.env.VITE_PUBLIC_TERMS_URL;
export const publicTaggingInformationUrl = import.meta.env
  .VITE_PUBLIC_TAGGING_INFORMATION_URL;

// More About Section Links
export const publicSociabilityWebsiteUrl = import.meta.env.VITE_PUBLIC_SOCIABILITY_WEBSITE_URL;
export const publicContactUsUrl = import.meta.env.VITE_PUBLIC_CONTACT_US_URL;
export const publicJoinCommunityUrl = import.meta.env.VITE_PUBLIC_JOIN_COMMUNITY_URL;
export const publicDownloadMobileUrl = import.meta.env.VITE_PUBLIC_DOWNLOAD_MOBILE_URL;

export const applicationEnvironment =
  import.meta.env.VITE_APPLICATION_ENVIRONMENT || "";

export const sentryDesktopTrackingEnable =
  import.meta.env.VITE_SENTRY_DESKTOP_TRACKING_ENABLE || "";
export const sentryDns = import.meta.env.VITE_SENTRY_DNS || "";
export const sentryTracingOriginHost =
  import.meta.env.VITE_SENTRY_TRACING_ORIGIN_HOST || "";
export const sentryTracingOriginUrl =
  import.meta.env.VITE_SENTRY_TRACING_ORIGIN_URL || "";

export const buildName = import.meta.env.VITE_BUILD_VERSION || "";
export const buildIOSNumber = import.meta.env.VITE_BUILD_IOS_NUMBER || "";
export const buildAndroidNumber =
  import.meta.env.VITE_BUILD_ANDROID_NUMBER || "";

export const enableAutoSuggest =
  (import.meta.env.VITE_ENABLE_AUTO_SUGGEST || "").toLowerCase() === "true";

// Feature: auto zoom map based on search results data
export const enableAutoZoom =
  (import.meta.env.VITE_ENABLE_AUTO_ZOOM || "").toLowerCase() === "true";

// Feature: Google fallback search when no results are found
export const enableGoogleFallback =
  (import.meta.env.VITE_ENABLE_GOOGLE_FALLBACK || "").toLowerCase() === "true";

// Feature: Enable 6-section mapper view on desktop home page
export const enableMapperSectionsDesktop =
  (import.meta.env.VITE_ENABLE_MAPPER_SECTIONS_DESKTOP || "false").toLowerCase() === "true";

export const onBoardingAlbumIdForDesktop =
  import.meta.env.VITE_ONBOARDING_ALBUM_ID_DESKTOP || "";

export const onBoardingAlbumIdDarkmodeForDesktop =
  import.meta.env.VITE_ONBOARDING_ALBUM_ID_DARKMODE_DESKTOP || "";

export const showNoticesTab =
  import.meta.env.VITE_SHOW_NOTICES_TAB || "";

export const showLoginByDefault =
  import.meta.env.VITE_SHOW_LOGIN_BY_DEFAULT || "";

export const showAcceptTAndCForNonLogin =
  import.meta.env.VITE_SHOW_ACCEPT_TANDC_FOR_NON_LOGIN || "";

export const termsAndConditionsAgreedKey =
  import.meta.env.VITE_TERMSANDCONDITIONS_AGREED_KEY || "";

  import.meta.env.VITE_SHOW_NOTICES_TAB || "";  

  export const googleMapsApiKey = "";
  export const googleMapsApiKeyIOS = "";
  export const googleMapsApiKeyAndroid = "";

export const  useBreakpointForVenueList =
  import.meta.env.VITE_USE_BREAKPOINT_FOR_VENUE_LIST || "";

// DEPRECATED: No longer used - Complex and Hybrid venues now use /complexvenuedetails route
export const ionicPublicUrl =
  import.meta.env.VITE_IONIC_PUBLIC_URL || "";  

export const backendUrl = 
  import.meta.env.VITE_BACKEND_URL || "";

export const enableShowVoteCounts =
    import.meta.env.VITE_ENABLE_SHOW_VOTE_COUNTS || "";

// Feature: Enable slide animation when clicking venue cards in search page
export const enableVenueAnimation =
  (import.meta.env.VITE_ENABLE_VENUE_ANIMATION || "true").toLowerCase() === "true";

// Phase 2: Enable Mixpanel CTA capture panel (Route, Page Name, Event Name, Data for Notion).
// Set VITE_MIXPANEL_CAPTURE_ENABLE=true in .env for local/dev; false or unset for production.
export const mixpanelCaptureEnable =
  (import.meta.env.VITE_MIXPANEL_CAPTURE_ENABLE || "false").toLowerCase() === "true";

export const mixpanelHost = import.meta.env.VITE_MIXPANEL_HOST || "";

export const lightModeStyles = [
  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },

  // NEW (from design export):
  // pointOfInterest label.visible = false  -> hide POI labels (not the POI itself)
  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },

  // Keep these overrides (so specific POI labels can still show)
  {
    featureType: "poi.attraction",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }],
  },
  // pointOfInterest.recreation.park label.visible = true -> show park labels
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }],
  },

  // Keep your existing ones unchanged
  {
    featureType: "poi.medical",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "transit",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "transit.station",
    stylers: [{ visibility: "on" }],
  },
];


export const darkModeStyles = [
  {
    elementType: "geometry",
    stylers: [{ color: "#1d2c4d" }],
  },
  {
    elementType: "labels.text.fill",
    stylers: [{ color: "#8ec3b9" }],
  },
  {
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1a3646" }],
  },

  {
    featureType: "administrative",
    elementType: "geometry",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "administrative.country",
    elementType: "geometry.stroke",
    stylers: [{ color: "#4b6878" }],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "labels.text.fill",
    stylers: [{ color: "#64779e" }],
  },
  {
    featureType: "administrative.province",
    elementType: "geometry.stroke",
    stylers: [{ color: "#4b6878" }],
  },

  /* ================================
     UPDATED BUILDING COLORS (Design)
     ================================ */

  {
    featureType: "landscape.man_made",
    elementType: "geometry.fill",
    stylers: [{ color: "#2f2f32" }], // building
  },
  {
    featureType: "landscape.man_made",
    elementType: "geometry.stroke",
    stylers: [{ color: "#334e87" }],
  },

  {
    featureType: "landscape.natural",
    elementType: "geometry",
    stylers: [{ color: "#1c1c1e" }], // urbanArea override
  },

  /* ================================
     POI FIX (IMPORTANT)
     Hide labels only (not geometry)
     ================================ */

  {
    featureType: "poi",
    elementType: "labels",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "poi",
    elementType: "geometry",
    stylers: [{ color: "#283d6a" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.fill",
    stylers: [{ color: "#6f9ba5" }],
  },
  {
    featureType: "poi",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1d2c4d" }],
  },

  {
    featureType: "poi.attraction",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "poi.medical",
    stylers: [{ visibility: "simplified" }],
  },

  /* Park override (design requires visible) */
  {
    featureType: "poi.park",
    elementType: "geometry.fill",
    stylers: [{ color: "#023e58" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "poi.park",
    elementType: "labels.text.fill",
    stylers: [{ color: "#3C7680" }],
  },

  /* ================================
     ROAD UPDATES
     ================================ */

  {
    featureType: "road",
    elementType: "geometry",
    stylers: [{ color: "#141415" }], // sidewalk design alignment
  },
  {
    featureType: "road",
    elementType: "labels.icon",
    stylers: [{ visibility: "off" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.fill",
    stylers: [{ color: "#98a5be" }],
  },
  {
    featureType: "road",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1d2c4d" }],
  },

  {
    featureType: "road.highway",
    elementType: "geometry",
    stylers: [{ color: "#2c6675" }],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.fill",
    stylers: [
      { color: "#cbc9f2" },
      { visibility: "on" },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "geometry.stroke",
    stylers: [
      { color: "#9693e5" },
      { visibility: "on" },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.fill",
    stylers: [{ color: "#b0d5ce" }],
  },
  {
    featureType: "road.highway",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#023e58" }],
  },

  /* ================================
     TRANSIT
     ================================ */

  {
    featureType: "transit",
    stylers: [{ visibility: "simplified" }],
  },
  {
    featureType: "transit",
    elementType: "labels.text.fill",
    stylers: [{ color: "#98a5be" }],
  },
  {
    featureType: "transit",
    elementType: "labels.text.stroke",
    stylers: [{ color: "#1d2c4d" }],
  },
  {
    featureType: "transit.line",
    elementType: "geometry.fill",
    stylers: [{ color: "#283d6a" }],
  },
  {
    featureType: "transit.station",
    stylers: [{ visibility: "on" }],
  },
  {
    featureType: "transit.station",
    elementType: "geometry",
    stylers: [{ color: "#3a4762" }],
  },

  /* ================================
     WATER
     ================================ */

  {
    featureType: "water",
    elementType: "geometry",
    stylers: [{ color: "#0e1626" }],
  },
  {
    featureType: "water",
    elementType: "labels.text.fill",
    stylers: [{ color: "#4e6d70" }],
  },
];
